import { render, staticRenderFns } from "./AulaButtons.vue?vue&type=template&id=7c546318&scoped=true&"
import script from "./AulaButtons.vue?vue&type=script&lang=js&"
export * from "./AulaButtons.vue?vue&type=script&lang=js&"
import style0 from "./AulaButtons.vue?vue&type=style&index=0&id=7c546318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c546318",
  null
  
)

export default component.exports